import {
  HTTP_METHOD_POST,
  apiRequest,
  commonRequestInstanceToAxiosRequestInfo,
} from '@/common/api/api.service'
import { API_BASE_URL } from '@/common/constant'

export const postUserPush = async (credential = '') => {
  try {
    const response = await apiRequest(
      commonRequestInstanceToAxiosRequestInfo({
        url: `${API_BASE_URL}/user/push`,
        method: HTTP_METHOD_POST,
        needCommonParams: true,
        headers: {
          'wavve-credential': credential,
        },
        data: {
          pushtype: 'marketing',
          apppush: 'y',
        },
      }),
    )

    if (!response) return { data: undefined }

    return response
  } catch (e) {
    console.error('postUserPush Network Error', e.message)
  }
}
